import { Routes } from '@angular/router';
import { profileCompleteGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  // Default → login
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // Steps 1-2 — enter phone, verify OTP
  {
    path: '',
    loadChildren: () => import('./pages/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },

  // Complete-profile is hidden for now — this portal only accepts users who
  // already finished registration & profile setup in the Trendly mobile app.

  // Shown once right after login when the account has more than one profile —
  // VerifyOtpComponent skips straight to /dashboard when there's exactly one.
  {
    path: 'select-profile',
    canActivate: [profileCompleteGuard],
    loadComponent: () => import('./pages/select-profile/select-profile.component').then(m => m.SelectProfileComponent),
  },

  // Public shared-profile page — no guard, no view limit (posts on it link to /shared/<postId>).
  {
    path: 'shared/profile/:profileId',
    loadComponent: () => import('./pages/shared/shared-profile.component').then(m => m.SharedProfileComponent),
  },

  // Public share landing page — no guard; anonymous visitors get a limited number of views.
  {
    path: 'shared/:shareId',
    loadComponent: () => import('./pages/shared/shared-aideo.component').then(m => m.SharedAideoComponent),
  },

  // Post-login creator dashboard (verified + profile-complete users only)
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
  },

  // Fallback added
  { path: '**', redirectTo: 'login' },
];
